// Post Model
import { Model } from '@vuex-orm/core';
import moment from 'moment';

export default class Notification extends Model {
    static entity = 'notifications';

    static fields() {
        return {
            id: this.attr(null),
            title: this.attr(''),
            body: this.attr(''),
            channel: this.attr(''),
            status: this.attr('success'),
        };
    }

}

window.Notification = Notification;
